import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { useSite } from "@/lib/site-context";

export default function StickyMobileCTA() {
  const { site } = useSite();
  const phone = site?.phone?.replace(/\s/g, "") || "";
  const wa = site?.whatsapp?.replace(/\D/g, "") || "";

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#050505]/95 backdrop-blur-xl border-t border-[#2E2E2E] p-3 flex items-center gap-2">
      <a
        href={`tel:${phone}`}
        data-testid="mobile-sticky-call-btn"
        className="flex-1 flex items-center justify-center gap-2 py-3 rounded-xl border border-[#2E2E2E] text-sm text-white"
      >
        <Phone className="w-4 h-4" /> Call
      </a>
      <a
        href={`https://wa.me/${wa}`}
        target="_blank"
        rel="noreferrer"
        data-testid="mobile-sticky-whatsapp-btn"
        className="flex-1 flex items-center justify-center gap-2 py-3 rounded-xl bg-[#25D366] text-white text-sm font-semibold"
      >
        <MessageCircle className="w-4 h-4" /> WhatsApp
      </a>
      <Link
        to="/book"
        data-testid="mobile-sticky-book-btn"
        className="flex-1 flex items-center justify-center gap-2 py-3 rounded-xl bg-[#D9A62E] text-[#050505] text-sm font-bold"
      >
        Book
      </Link>
    </div>
  );
}
